import { DeliveryRoute } from '../types/DeliveryRouteTypes'

export const checkBackToStoreStop = (route: DeliveryRoute) =>
    route?.stops?.some((stop) => stop.stopType === 'back_to_store')